import { render, staticRenderFns } from "./groupPlan.vue?vue&type=template&id=57488182&scoped=true"
import script from "./groupPlan.vue?vue&type=script&lang=js"
export * from "./groupPlan.vue?vue&type=script&lang=js"
import style0 from "./groupPlan.vue?vue&type=style&index=0&id=57488182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57488182",
  null
  
)

export default component.exports